module.exports = __webpack_public_path__ + "static/media/vino-2.9bd072eb.jpg";